import React, { useState, useEffect, createContext } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { Roofing, AssistWalker, Diversity3, Apps, ContactPhone } from "@mui/icons-material";
import apilink from "../apiURL/baseUrls";
import axios from "axios";

import "@fontsource/open-sans"; // Defaults to weight 400
import "@fontsource/open-sans/400.css"; // Specify weight
import "@fontsource/open-sans/400-italic.css"; // Specify weight and style

import "@fontsource/caveat"; // Defaults to weight 400
import "@fontsource/caveat/400.css"; // Specify weight

export const LayoutContext =  createContext();

const AdminLayout = () => {
  const [screen, setScreen] = useState("home");
  const [members, setMembers] = useState(0);
  const [sick, setSick] = useState(0);
  const [died, setDied] = useState(0);
  const navigate = useNavigate();

  const fetchData = async () => {
    
    const storedUser = await JSON.parse(
      localStorage.getItem("userSessionData")
    );

    const baseUrl = apilink.link;
    await axios
    .get(`${baseUrl}/family/statistics/${storedUser.familycode}`, {
        headers: {
          "Content-Type": "application/json",
        },
      })

      .then((response) => {
        if (response.data.message == "Successfull") {
          setSick(
            response.data.sickmembers
          );
          setDied(
            response.data.diedmembers
          );
        }
      })
      .catch((error) => {
       
        console.log("rrrr"+error.response.data.message);
      });
  };

  useEffect(() => {
    const getAsyncData = async () => {
    
      const storedUser = await JSON.parse(
        localStorage.getItem("userSessionData")
      );
 
      const baseUrl = apilink.link;
      await axios
      .get(`${baseUrl}/family/statistics/${storedUser.familycode}`, {
          headers: {
            "Content-Type": "application/json",
          },
        })

        .then((response) => {
          if (response.data.message == "Successfull") {
            setMembers(
              response.data.allmembers
            );
            setSick(
              response.data.sickmembers
            );
            setDied(
              response.data.diedmembers
            );
          }
        })
        .catch((error) => {
         
          console.log("rrrr"+error.response.data.message);
        });
    };
    getAsyncData();
  }, []);

  const handleNavigation = async (route) => {
    setScreen(route);
    navigate("/admin/" + route);
  };

  return (
    <LayoutContext.Provider value={{fetchData}}>
      <nav
        style={{ paddingInline: "15px" }}
        className="navbar fixed-top navbar-light bg-light"
      >
        
          <h1 className="navbar-brand mb-0" style={{ fontFamily: "Caveat", fontSize: 20}}>family<b>Tree</b></h1>
          <img
            alt="logo"
            style={{ width: "80px", height: "50px", resizeMode: "stretch" }}
            src={require("./pic1.webp")}
          />
       
      </nav>
      <div className="container-fluid">
        <div id="page-home" className="active">
          <div className="block" style={{ marginTop: "80px", marginBottom: "80px"}}>
            {/* <h2>The standard Lorem Ipsum passage, used since the 1500s</h2> */}
            <Outlet />
          </div>
        </div>
      </div>
      <footer className="footer">
        <div
          id="buttonGroup"
          className="btn-group selectors"
          role="group"
          aria-label="Basic example"
        >
          <button
            id="home"
            type="button"
            className="btn btn-secondary button-active"
          >
            <div
              onClick={() => handleNavigation("home")}
              className="selector-holder"
            >
              <center>
                <Roofing style={screen === "home"?{color: '#547FF7'}:{color: '#EA6C82'}}/>
                <br />
                <span style={screen === "home"?{color: '#547FF7',fontFamily: "Open Sans"}:{color: '#EA6C82',fontFamily: "Open Sans"}}>Home</span>
              </center>
            </div>
          </button>
          <button
            id="account"
            type="button"
            className="btn btn-secondary button-inactive"
          >
            <div
              onClick={() => handleNavigation("contacts")}
              className="selector-holder"
            >
              <center>
                <ContactPhone style={screen === "contacts"?{color: '#547FF7'}:{color: '#EA6C82'}}/>
                <br />
                <span style={screen === "contacts" ?{color: '#547FF7', fontFamily: "Open Sans"}:{color: '#EA6C82', fontFamily: "Open Sans"}}>Members({members})</span>
              </center>
            </div>
          </button>
          <button
            id="feed"
            type="button"
            className="btn btn-secondary button-inactive"
          >
            <div
              onClick={() => handleNavigation("sick")}
              className="selector-holder"
            >
              <center>
              <AssistWalker style={screen === "sick"?{color: '#547FF7'}:{color: '#EA6C82'}}/>
                <br />
                <span style={screen === "sick"?{color: '#547FF7',fontFamily: "Open Sans"}:{color: '#EA6C82',fontFamily: "Open Sans"}}>Sick({sick})</span>
              </center>
            </div>
          </button>
          <button
            id="create"
            type="button"
            className="btn btn-secondary button-inactive"
          >
            <div
              onClick={() => handleNavigation("late")}
              className="selector-holder"
            >
              <center>
                <Diversity3 style={screen === "late"?{color: '#547FF7'}:{color: '#EA6C82'}}/>
                <br />
                <span style={screen === "late"?{color: '#547FF7',fontFamily: "Open Sans"}:{color: '#EA6C82',fontFamily: "Open Sans"}}>Late({died})</span>
              </center>
            </div>
          </button>
         
          <button
            id="account"
            type="button"
            className="btn btn-secondary button-inactive"
          >
            <div
              onClick={() => handleNavigation("more")}
              className="selector-holder"
            >
              <center>
                <Apps style={screen === "more" || screen === "profile" ?{color: '#547FF7'}:{color: '#EA6C82'}}/>
                <br />
                <span style={screen === "more" || screen === "profile" ?{color: '#547FF7', fontFamily: "Open Sans"}:{color: '#EA6C82', fontFamily: "Open Sans"}}>More</span>
              </center>
            </div>
          </button>
        </div>
      </footer>
    </LayoutContext.Provider>
  );
};

export default AdminLayout;
